import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { writeMessageActions, archivedActions } from "../../../_store";
import { CreateEventLogTextFileForInbox } from "../EventLog/EventLog";
import { getStoredValue, removeStoredValue, setStoredValue } from "../../../_helpers/storagehelper";

const useDraft = () => {
  const UserID = getStoredValue("userID");
  const dispatch = useDispatch();

  const initialDraft = {
    draftID: 0,
    publicUserId: UserID || "",
    inmateID: 0,
    subject: "",
    messageBody: "",
    draftFromValue: 3,
    messageID: 0,
    isSALoginAsPU: 0,
    action: 1,
  };

  const [isDraftModified, setIsDraftModified] = useState(false);
  const [draftMsg, setDraftMsg] = useState(() => {
    const savedDraft = getStoredValue("draft");
    return savedDraft ? savedDraft : initialDraft;
  });
  const [isSaveDraftModified, setIsSaveDraftModified] = useState(false);

  useEffect(() => {
    if (isDraftModified && draftMsg?.messageBody !== "") {
      const trimmedMessageSubject = draftMsg?.subject?.trim();
      const trimmedMessageBody = draftMsg?.messageBody?.trim(); // Trim the messageBody
      const updatedDraftMsg = {
        ...draftMsg, // Spread the existing draftMsg properties
        messageBody: trimmedMessageBody, // Update the messageBody with the trimmed value
        subject: trimmedMessageSubject,
      };

      setStoredValue("draft", updatedDraftMsg); 
    }
  }, [draftMsg, isDraftModified]);

  // Effect to handle saving the draft to the backend
  useEffect(() => {
    if (isSaveDraftModified) {
      const savedDraft = getStoredValue("draft");
      if (savedDraft != null && savedDraft?.messageBody?.trim() !== "") {
        dispatch(writeMessageActions.DraftMessageCUD(savedDraft)).then(
          (res) => {
            const response = res?.payload;
            clearDraft(); // Clear draft after saving
            const publicUserId = getStoredValue("userID");
            dispatch(
              archivedActions.PULoginUnreadNotificationCount({ publicUserId })
            );

            CreateEventLogTextFileForInbox(
              dispatch,
              `Auto Save Draft Message ( Draft From value - ${draftMsg?.DraftFromValue} ) `,
              "---",
              "---",
              `${
                response?.ReturnDraft !== null
                  ? `Auto Save - Save Message as draft successfully. Return value -`
                  : ``
              }`
            );
          }
        );
      } else {
        clearDraft();
      }
    }
  }, [isSaveDraftModified, dispatch]);

  // Handle draft changes
  const handleDraftChange = useCallback((fieldname, fieldvalue) => {
    setDraftMsg((prevDraftMsg) => ({
      ...prevDraftMsg,
      [fieldname]: fieldvalue,
    }));
    setIsDraftModified(true);
  }, []);

  // Clear the draft
  const clearDraft = useCallback(() => {
    setIsSaveDraftModified(false);
    setDraftMsg(initialDraft);
    setIsDraftModified(false);
    removeStoredValue("draft");
  }, [initialDraft]);

  return {
    isDraftModified,
    draftMsg,
    setIsDraftModified,
    handleDraftChange,
    clearDraft,
    setIsSaveDraftModified,
    isSaveDraftModified,
  };
};

export default useDraft;
